import { isApiSupported } from './llmGatewayConstants';
import type { GatewayFormState, GovernanceSettings, RegisteredLlm } from './llmGatewayTypes';

export function validateGovernance(governance: GovernanceSettings): Record<string, string> {
  const errors: Record<string, string> = {};
  if (governance.rateLimiting && (!governance.rateLimitPerMinute || governance.rateLimitPerMinute < 1)) {
    errors.rateLimitPerMinute = 'Enter a rate limit of at least 1 request per minute.';
  }
  if (governance.tokenQuotas && (!governance.tokenQuotaMonthly || governance.tokenQuotaMonthly < 1)) {
    errors.tokenQuotaMonthly = 'Enter a monthly token quota greater than zero.';
  }
  if (governance.gatewayInstructions && !governance.gatewayInstructionsText.trim()) {
    errors.gatewayInstructionsText = 'Enter gateway instructions, or turn this policy off.';
  }
  return errors;
}

export function validateStep(form: GatewayFormState, step: number, models: RegisteredLlm[] = []): Record<string, string> {
  const errors: Record<string, string> = {};
  const findModel = (id: string) => models.find((model) => model.id === id);

  if (step >= 0) {
    if (!form.name.trim()) errors.name = 'Enter a gateway name.';
    if (!form.llmType) errors.llmType = 'Select an LLM type.';
    if (!form.modelId) errors.modelId = 'Select a registered LLM.';
    else {
      const model = findModel(form.modelId);
      if (!model) errors.modelId = 'The selected model is no longer registered.';
      else if (form.llmType && model.type !== form.llmType) {
        errors.modelId = 'Selected model does not match the LLM type.';
      }
    }
  }

  if (step >= 1) {
    const model = findModel(form.modelId);
    if (!form.apiTypes.length) {
      errors.apiTypes = 'Select at least one compatible gateway API type.';
    } else if (model) {
      const invalid = form.apiTypes.filter((apiType) => !isApiSupported(model, apiType));
      if (invalid.length) errors.apiTypes = 'Remove API types that are not supported by this model.';
    }
    if (form.apiTypes.includes('custom') && !form.customEndpoint.trim()) {
      errors.customEndpoint = 'Enter a custom endpoint for the Custom API type.';
    }
  }

  if (step >= 2) {
    if (!form.authMethod) errors.authMethod = 'Select an authentication method.';
    Object.assign(errors, validateGovernance(form.governance));
  }

  return errors;
}

export function firstError(errors: Record<string, string>): string | null {
  return Object.values(errors)[0] ?? null;
}
